import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './TrialExpiredModal.css';

interface TrialExpiredModalProps {
  onClose: () => void;
  variant?: 'expired' | 'extension';
  onExtend?: () => Promise<void>;
}

const TrialExpiredModal: React.FC<TrialExpiredModalProps> = ({ onClose, variant = 'expired', onExtend }) => {
  const navigate = useNavigate();
  const [isExtending, setIsExtending] = useState(false);
  const [extendError, setExtendError] = useState<string | null>(null);

  const handleViewPlans = () => {
    navigate('/plans');
    onClose();
  };

  const handleExtendTrial = async () => {
    if (!onExtend) {
      return;
    }

    setExtendError(null);
    setIsExtending(true);

    try {
      await onExtend();
    } catch (error) {
      setExtendError(error instanceof Error ? error.message : 'Failed to extend trial. Please try again.');
    } finally {
      setIsExtending(false);
    }
  };

  const isExtensionVariant = variant === 'extension';

  return (
    <div className="trial-modal-overlay">
      <div className="trial-modal-content" onClick={e => e.stopPropagation()}>
        <div className="trial-modal-icon">
          <i className="bi bi-exclamation-triangle-fill"></i>
        </div>

        <h2 className="trial-modal-title">
          {isExtensionVariant ? 'Your trial has ended' : 'Your trial has expired'}
        </h2>

        <p className="trial-modal-message">
          {isExtensionVariant
            ? 'Your 7-day trial period has ended. You can extend it once for 7 additional days to keep exploring DISGENET.'
            : 'Your trial period has ended. To continue accessing DISGENET features, please choose a plan that fits your needs.'}
        </p>

        {extendError && <p className="trial-modal-error">{extendError}</p>}

        <div className="trial-modal-actions">
          {isExtensionVariant && (
            <button
              className="btn-gradient-blue trial-modal-btn-primary"
              onClick={handleExtendTrial}
              disabled={isExtending}
            >
              {isExtending ? 'Extending trial...' : 'Extend trial 7 days'}
            </button>
          )}
          <button
            className={`${isExtensionVariant ? 'trial-modal-btn-secondary' : 'btn-gradient-pink trial-modal-btn-primary'}`}
            onClick={handleViewPlans}
            disabled={isExtending}
          >
            View Plans
          </button>
        </div>
      </div>
    </div>
  );
};

export default TrialExpiredModal;
